import { erzeugeTaktischesZeichen } from '@taktische-zeichen/core';

// Taktische Zeichen nach DV 102 via @taktische-zeichen/core (MIT).
// Zuordnung der Planspiel-Fahrzeuge und -Symbole zu Grundzeichen, Organisation,
// Fachaufgabe und Symbol. Anpassungen an der Darstellung nur hier vornehmen.

const FW = 'feuerwehr';
const HIORG = 'hilfsorganisation';

const KFZ = 'kraftfahrzeug-landgebunden';

// ==================== FAHRZEUGE ====================

// Spezifische Zuordnung nach Fahrzeugname (hat Vorrang vor dem Typ)
const VEHICLE_BY_NAME = {
  'DLK 23/12': { symbol: 'drehleiter' },
  'DLK 18/12': { symbol: 'drehleiter' },
  'TM 50': { fachaufgabe: 'hoehenrettung' },
  'TM 32': { fachaufgabe: 'hoehenrettung' },
  'HAB': { fachaufgabe: 'hoehenrettung' },
  'FwK': { fachaufgabe: 'heben' },
  'KEF': { fachaufgabe: 'technische-hilfeleistung' },
  'SW 2000': { fachaufgabe: 'wasserversorgung' },
  'GW-L1': { fachaufgabe: 'logistik' },
  'GW-L2': { fachaufgabe: 'logistik' },
  'GW-N': { fachaufgabe: 'logistik' },
  'GW-G': { fachaufgabe: 'abc' },
  'GW-AS': { fachaufgabe: 'abc' },
  'GW-A2': { fachaufgabe: 'abc' },
  'GW-Mess': { fachaufgabe: 'messen' },
  'GW-Höhe': { fachaufgabe: 'hoehenrettung' },
  'GW-W': { fachaufgabe: 'wasserrettung' },
  'GW-Taucher': { fachaufgabe: 'wasserrettung' },
  'GW-Tier': { fachaufgabe: 'veterinaerwesen' },
  'GW-Öl': { fachaufgabe: 'umweltschaeden-gewaesser' },
  'GW-IuK': { fachaufgabe: 'iuk' },
  'GW-San': { organisation: HIORG, fachaufgabe: 'rettungswesen' },
  'AB-A': { grundzeichen: 'abrollbehaelter' },
  'AB-Rüst': { grundzeichen: 'abrollbehaelter', fachaufgabe: 'technische-hilfeleistung' },
  'AB-Schlauch': { grundzeichen: 'abrollbehaelter', fachaufgabe: 'wasserversorgung' },
  'AB-Mulde': { grundzeichen: 'abrollbehaelter', fachaufgabe: 'transport' },
  'AB-EL': { grundzeichen: 'abrollbehaelter', fachaufgabe: 'fuehrung' },
  'AB-Dekon': { grundzeichen: 'abrollbehaelter', fachaufgabe: 'dekontamination' },
  'AB-MANV': { grundzeichen: 'abrollbehaelter', fachaufgabe: 'rettungswesen' },
  'Dekon-P': { fachaufgabe: 'dekontamination-personen' },
  'Dekon-G': { fachaufgabe: 'dekontamination-geraete' },
  'Dekon-V': { fachaufgabe: 'dekontamination-personen' },
  'FlA': { grundzeichen: 'anhaenger', fachaufgabe: 'brandbekaempfung' },
  'StA': { grundzeichen: 'anhaenger', fachaufgabe: 'versorgung-elektrizitaet' },
  'LiMa': { grundzeichen: 'anhaenger', fachaufgabe: 'beleuchtung' },
  'NEF': { organisation: HIORG, fachaufgabe: 'aerztliche-versorgung' },
  'NAW': { organisation: HIORG, fachaufgabe: 'aerztliche-versorgung' },
  'Notarzt PKW': { organisation: HIORG, fachaufgabe: 'aerztliche-versorgung' },
  'KdoW LNA': { organisation: HIORG, fachaufgabe: 'fuehrung' },
  'KdoW OrgL': { organisation: HIORG, fachaufgabe: 'fuehrung' },
  'Pol-Hub': { grundzeichen: 'hubschrauber', organisation: 'polizei' },
  'Krad': { grundzeichen: 'kraftrad' },
  'SEK': { grundzeichen: 'taktische-formation', organisation: 'polizei' },
  'MEK': { grundzeichen: 'taktische-formation', organisation: 'polizei' },
  'GKW': { fachaufgabe: 'bergung' },
  'GKW I': { fachaufgabe: 'bergung' },
  'LKW-K': { fachaufgabe: 'transport' },
  'LKW-Lkr': { fachaufgabe: 'heben' },
  'BRmG': { fachaufgabe: 'raeumen' },
  'Radlader': { fachaufgabe: 'raeumen' },
  'FGr R': { grundzeichen: 'taktische-formation', fachaufgabe: 'raeumen' },
  'FGr W': { grundzeichen: 'taktische-formation', fachaufgabe: 'abwehr-wassergefahren' },
  'FGr O': { grundzeichen: 'taktische-formation', fachaufgabe: 'bergung' },
  'FGr E': { grundzeichen: 'taktische-formation', fachaufgabe: 'versorgung-elektrizitaet' },
  'FGr Bel': { grundzeichen: 'taktische-formation', fachaufgabe: 'beleuchtung' },
  'RTB DLRG': { grundzeichen: 'wasserfahrzeug' },
  'GW-W DLRG': { fachaufgabe: 'wasserrettung' },
  'GW-Taucher DLRG': { fachaufgabe: 'wasserrettung' },
  'SanZug': { grundzeichen: 'taktische-formation', einheit: 'zug', fachaufgabe: 'rettungswesen' },
  'SEG': { grundzeichen: 'taktische-formation', einheit: 'gruppe', fachaufgabe: 'rettungswesen' },
};

// Allgemeine Zuordnung nach Fahrzeugtyp
const VEHICLE_BY_TYPE = {
  LF: { fachaufgabe: 'brandbekaempfung' },
  HLF: { fachaufgabe: 'brandbekaempfung' },
  TLF: { fachaufgabe: 'brandbekaempfung' },
  TSF: { fachaufgabe: 'brandbekaempfung' },
  MLF: { fachaufgabe: 'brandbekaempfung' },
  DLK: { symbol: 'drehleiter' },
  RW: { fachaufgabe: 'technische-hilfeleistung' },
  ELW: { fachaufgabe: 'fuehrung' },
  KdoW: { fachaufgabe: 'fuehrung' },
  WLF: { grundzeichen: 'wechsellader' },
  AB: { grundzeichen: 'abrollbehaelter' },
  Boot: { grundzeichen: 'wasserfahrzeug' },
  'Anhänger': { grundzeichen: 'anhaenger' },
  RTW: { organisation: HIORG, fachaufgabe: 'rettungswesen' },
  KTW: { organisation: HIORG, fachaufgabe: 'transport' },
  GRTW: { organisation: HIORG, fachaufgabe: 'rettungswesen' },
  PT: { organisation: HIORG, grundzeichen: 'taktische-formation', fachaufgabe: 'transport' },
  NEF: { organisation: HIORG, fachaufgabe: 'aerztliche-versorgung' },
  NAW: { organisation: HIORG, fachaufgabe: 'aerztliche-versorgung' },
  RTH: { organisation: HIORG, grundzeichen: 'hubschrauber' },
  ITH: { organisation: HIORG, grundzeichen: 'hubschrauber' },
  Betr: { organisation: HIORG, fachaufgabe: 'betreuung' },
  BHP: { organisation: HIORG, fachaufgabe: 'aerztliche-versorgung' },
  OrgL: { organisation: HIORG, grundzeichen: 'person', funktion: 'fuehrungskraft' },
  LNA: { organisation: HIORG, grundzeichen: 'person', funktion: 'fuehrungskraft' },
  POL: { organisation: 'polizei' },
  THW: { organisation: 'thw' },
  DLRG: { organisation: HIORG },
  PKW: { organisation: HIORG },
  FR: { organisation: HIORG, fachaufgabe: 'rettungswesen' },
  SEG: { organisation: HIORG },
  SanZug: { organisation: HIORG },
};

// Grundzeichen, die eine Typbezeichnung im Zeichen tragen können
const TYP_GRUNDZEICHEN = new Set([
  KFZ, 'wechsellader', 'abrollbehaelter', 'anhaenger', 'wasserfahrzeug',
]);

// Text, der in das SVG geschrieben wird – Sonderzeichen würden das SVG zerstören
const cleanText = (value) => String(value ?? '').replace(/[<>&"'\]]/g, '').trim().substring(0, 20);

export const vehicleZeichenSpec = (vehicle) => {
  const spec = {
    grundzeichen: KFZ,
    organisation: FW,
    ...VEHICLE_BY_TYPE[vehicle?.type],
    ...VEHICLE_BY_NAME[vehicle?.name],
  };
  const name = cleanText(vehicle?.name);
  // Funkrufname (nur im Szenario vergeben) erscheint als Name im Zeichen
  const callsign = cleanText(vehicle?.callsign).substring(0, 20);
  if (spec.grundzeichen === 'person' || spec.grundzeichen === 'taktische-formation') {
    if (!spec.fachaufgabe) spec.text = name;
    if (callsign && spec.grundzeichen === 'taktische-formation') spec.name = callsign;
  } else if (TYP_GRUNDZEICHEN.has(spec.grundzeichen)) {
    spec.typ = name;
    if (callsign) spec.name = callsign;
  }
  return spec;
};

// ==================== DV 102 SYMBOLE ====================

const SYMBOL_ZEICHEN = {
  // Gefahren
  'gefahr-brand': { grundzeichen: 'gefahr', symbol: 'entstehungsbrand' },
  'gefahr-explosion': { grundzeichen: 'gefahr', text: 'Ex' },
  'gefahr-einsturz': { grundzeichen: 'gefahr', symbol: 'teilzerstoert' },
  'gefahr-strom': { grundzeichen: 'gefahr', symbol: 'elektrizitaet' },
  'gefahr-gas': { grundzeichen: 'gefahr', text: 'Gas' },
  'gefahr-atom': { grundzeichen: 'gefahr', text: 'A' },
  'gefahr-biologisch': { grundzeichen: 'gefahr', text: 'B' },
  'gefahr-chemisch': { grundzeichen: 'gefahr', text: 'C' },
  'gefahr-wasser': { grundzeichen: 'gefahr', symbol: 'wasser' },
  'gefahr-absturz': { grundzeichen: 'gefahr', text: 'Abst' },

  // Schadenereignisse
  'schaden-feuer': { symbol: 'fortentwickelter-brand' },
  'schaden-vu': { grundzeichen: 'anlass', text: 'VU' },
  'schaden-vu-lkw': { grundzeichen: 'anlass', text: 'VU Lkw' },
  'schaden-zug': { grundzeichen: 'anlass', text: 'Zug' },
  'schaden-flugzeug': { grundzeichen: 'anlass', symbol: 'flugzeug' },
  'schaden-gefahrgut': { grundzeichen: 'anlass', symbol: 'abc' },
  'schaden-gebaeude': { grundzeichen: 'gebaeude', symbol: 'zerstoert' },
  'schaden-wasser': { grundzeichen: 'anlass', symbol: 'wasser' },
  'schaden-person': { symbol: 'person-verletzt' },
  'schaden-tier': { symbol: 'tier-verletzt' },

  // Führungsstellen
  'fuehrung-el': { grundzeichen: 'befehlsstelle', organisation: FW, text: 'EL' },
  'fuehrung-eal': { grundzeichen: 'befehlsstelle', organisation: FW, text: 'EAL' },
  'fuehrung-tel': { grundzeichen: 'befehlsstelle', organisation: 'fuehrung', text: 'TEL' },
  'fuehrung-oel': { grundzeichen: 'befehlsstelle', organisation: 'fuehrung', text: 'ÖEL' },
  'fuehrung-stab': { grundzeichen: 'befehlsstelle', organisation: 'fuehrung', fachaufgabe: 'fuehrung' },
  'fuehrung-kats': { grundzeichen: 'befehlsstelle', organisation: 'gefahrenabwehr', text: 'KatS' },

  // Räume / Plätze
  'raum-bereitstellung': { grundzeichen: 'stelle', organisation: FW, text: 'BR' },
  'raum-sammelplatz': { grundzeichen: 'stelle', organisation: FW, symbol: 'sammeln' },
  'raum-sammelstelle': { grundzeichen: 'stelle', organisation: HIORG, symbol: 'sammelplatz-betroffene' },
  'raum-uebergabe': { grundzeichen: 'stelle', organisation: FW, text: 'ÜP' },
  'raum-logistik': { grundzeichen: 'stelle', organisation: FW, fachaufgabe: 'logistik' },

  // Medizinisch
  'med-behandlungsplatz': { grundzeichen: 'stelle', organisation: HIORG, fachaufgabe: 'aerztliche-versorgung' },
  'med-patientenablage': { grundzeichen: 'stelle', organisation: HIORG, symbol: 'person-zu-transportieren' },
  'med-sichtung': { grundzeichen: 'stelle', organisation: HIORG, symbol: 'sichten' },
  'med-rettungsmittel': { grundzeichen: 'stelle', organisation: HIORG, symbol: 'fahrzeug' },
  'med-hubschrauber': { grundzeichen: 'stelle', organisation: HIORG, symbol: 'hubschrauber' },
  'med-totenablage': { grundzeichen: 'stelle', organisation: HIORG, symbol: 'person-tot' },
  'med-betreuung': { grundzeichen: 'stelle', organisation: HIORG, fachaufgabe: 'betreuung' },
  'med-notaufnahme': { grundzeichen: 'ortsfeste-stelle', organisation: HIORG, fachaufgabe: 'krankenhaus' },

  // Atemschutz
  'atemschutz-sammelplatz': { grundzeichen: 'stelle', organisation: FW, text: 'AS' },
  'atemschutz-ueberwachung': { grundzeichen: 'stelle', organisation: FW, text: 'ASÜ' },
  'atemschutz-notfall': { grundzeichen: 'taktische-formation', organisation: FW, einheit: 'trupp', text: 'SiTr' },

  // Wasserversorgung
  'wasser-hydrant': { grundzeichen: 'ortsfeste-stelle', organisation: FW, symbol: 'wasser' },
  'wasser-brunnen': { grundzeichen: 'ortsfeste-stelle', organisation: FW, fachaufgabe: 'versorgung-brauchwasser' },
  'wasser-entnahme': { grundzeichen: 'stelle', organisation: FW, symbol: 'wasser' },
  'wasser-behaelter': { grundzeichen: 'stelle', organisation: FW, symbol: 'brauchwasser' },
  'wasser-pumpe': { grundzeichen: 'stelle', organisation: FW, symbol: 'pumpe' },

  // Infrastruktur
  'infra-gesperrt': { symbol: 'blockiert' },
  'infra-umleitung': { symbol: 'teilblockiert' },
  'infra-bruecke': { symbol: 'bruecke' },
  'infra-bahnuebergang': { grundzeichen: 'anlass', text: 'BÜ' },
  'infra-tankstelle': { grundzeichen: 'ortsfeste-stelle', organisation: 'zivil', fachaufgabe: 'verbrauchsgueter' },
  'infra-stromausfall': { grundzeichen: 'anlass', symbol: 'elektrizitaet' },

  // Kommunikation
  'komm-funk': { grundzeichen: 'stelle', organisation: FW, fachaufgabe: 'iuk' },
  'komm-bos': { grundzeichen: 'stelle', organisation: FW, symbol: 'relaisfunkbetrieb' },
  'komm-lautsprecher': { symbol: 'lautsprecher' },
  'komm-sirene': { symbol: 'sirene' },
  'komm-presse': { grundzeichen: 'stelle', organisation: 'fuehrung', text: 'Pr' },

  // Sonstige
  'sonstige-person-vermisst': { symbol: 'person-vermisst' },
  'sonstige-person-gefunden': { symbol: 'person-gerettet' },
  'sonstige-beleuchtung': { symbol: 'beleuchtung' },
  'sonstige-strom': { symbol: 'elektrizitaet' },
  'sonstige-verpflegung': { grundzeichen: 'stelle', organisation: HIORG, fachaufgabe: 'verpflegung' },
  'sonstige-wc': { grundzeichen: 'stelle', organisation: 'zivil', text: 'WC' },
  'sonstige-info': { grundzeichen: 'stelle', organisation: 'fuehrung', text: 'i' },
  'sonstige-gefahr': { grundzeichen: 'gefahr', text: '!' },
};

export const symbolZeichenSpec = (symbol) => SYMBOL_ZEICHEN[symbol?.symbolId || symbol?.id] || null;

// ==================== RENDERING ====================

const cache = new Map();

// Liefert { url, size } oder null, wenn kein Zeichen erzeugt werden kann
export const renderZeichen = (spec) => {
  if (!spec) return null;
  const key = JSON.stringify(spec);
  if (!cache.has(key)) {
    try {
      const zeichen = erzeugeTaktischesZeichen(spec);
      cache.set(key, { url: zeichen.dataUrl, size: zeichen.size });
    } catch (error) {
      console.warn('Taktisches Zeichen konnte nicht erzeugt werden:', spec, error);
      cache.set(key, null);
    }
  }
  return cache.get(key);
};

// Skaliert ein Zeichen auf eine Zielhöhe in Pixeln
export const scaledSize = (size, height) => {
  const [w, h] = size;
  return [Math.round((w / h) * height), height];
};

// ==================== SONDERFORMEN ====================

// Richtungspfeile und Sichtungskategorien sind keine Grundzeichen der Bibliothek
// und werden als eigene SVGs gezeichnet.
const ARROW_STYLES = {
  'pfeil-angriff': { color: '#fa321e' },
  'pfeil-rueckzug': { color: '#003399', dashed: true },
  'pfeil-anmarsch': { color: '#16a34a' },
  'pfeil-abmarsch': { color: '#6b7280', dashed: true },
  'pfeil-wind': { color: '#374151', wind: true },
  'pfeil-ausbreitung': { color: '#fa321e', dashed: true },
  'pfeil-strom': { color: '#2563eb' },
  'infra-einbahn': { color: '#374151' },
};

export const isArrowSymbol = (symbol) => Boolean(ARROW_STYLES[symbol?.symbolId || symbol?.id]);

// Pfeil zeigt bei rotation = 0 nach Osten
export const arrowSvg = (symbol, rotation = 0, size = 56) => {
  const style = ARROW_STYLES[symbol?.symbolId || symbol?.id] || { color: '#fa321e' };
  const dash = style.dashed ? 'stroke-dasharray="7,5"' : '';
  const shaft = style.wind
    ? `<path d="M6 28 H40" stroke="${style.color}" stroke-width="4"/>
       <path d="M10 28 L4 18 M17 28 L11 18 M24 28 L18 18" stroke="${style.color}" stroke-width="3"/>`
    : `<path d="M6 28 H40" stroke="${style.color}" stroke-width="5" ${dash}/>`;
  return `
    <svg width="${size}" height="${size}" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg"
         style="transform: rotate(${Number(rotation) || 0}deg); transform-origin: 50% 50%; overflow: visible">
      <g fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path d="M6 28 H40" stroke="white" stroke-width="9" opacity="0.7"/>
        ${shaft}
        <path d="M36 16 L52 28 L36 40 Z" fill="${style.color}" stroke="white" stroke-width="2"/>
      </g>
    </svg>`;
};

const SICHTUNG = {
  'sichtung-rot': { color: '#dc2626', text: 'I', textColor: 'white' },
  'sichtung-gelb': { color: '#facc15', text: 'II', textColor: 'black' },
  'sichtung-gruen': { color: '#16a34a', text: 'III', textColor: 'white' },
  'sichtung-blau': { color: '#2563eb', text: 'IV', textColor: 'white' },
  'sichtung-schwarz': { color: '#111827', text: '†', textColor: 'white' },
};

export const sichtungSvg = (symbol, size = 32) => {
  const sk = SICHTUNG[symbol?.symbolId || symbol?.id];
  if (!sk) return null;
  return `
    <svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="14" fill="${sk.color}" stroke="white" stroke-width="2"/>
      <text x="16" y="21" text-anchor="middle" font-size="13" font-weight="700" font-family="sans-serif" fill="${sk.textColor}">${sk.text}</text>
    </svg>`;
};
